<template>
  <page style="margin-bottom: 20px;">
    <skeleton-loader :loading="loading" type="heading" slot="page-title">
      <div class="mb-1" style="display: flex; align-items: center;">
        <span class="mr-1" v-if="currentModel">
          {{ election.raceName }}
          <template v-if="chamber.toLowerCase().includes('runoff')">Runoff</template>
        </span>
        <span
          v-if="currentModel && currentModel.rating"
          class="race-state"
          :style="'background-color: ' + getColor"
          v-html="getRaceState">
        </span>
      </div>
    </skeleton-loader>
    <template slot="page-subtitle">
      <skeleton-loader :loading="loading" type="chip">
        <template v-if="currentModel">Last Model Update: <b> {{ currentModel.date | readableDate }}</b></template>
      </skeleton-loader>
    </template>
    <v-row>
      <!-- <v-col cols="12">
        <detail-overview :election="election" :model="currentModel" :chamber="chamber" class="mb-5"></detail-overview>
      </v-col> -->
      <v-col cols="12">
        <headline
          :candidates="currentModel ? Object.values(election.electionJson.currentElection) : null"
          :model="currentModel"
          prop="gopWinProbability"
          :loading="loading"
          :presidential="chamber === 'president'">
        </headline>
      </v-col>

      <v-col cols="12" class="mb-5">
        <h2 class="mb-4">How Our Model Has Changed</h2>
        <skeleton-loader :loading="loading">
          <time-series
            v-if="models.length > 0"
            title="Chance of Winning"
            :key="`chanceOfWinning-${chartKey}`"
            @on-mouseout="chartKey += 1"
            @scoreboard-update="scoreboardData = $event"
            :scoreboardData="scoreboardData"
            :data="models"
            :chamber="chamber"
            prop="gopWinProbability"
            name="gopWinProbability">
          </time-series>
        </skeleton-loader>
      </v-col>

      <v-col cols="12">
        <detail-notes
          :election="currentModel ? election : null"
          :chamber="chamber"
          :currentModel="currentModel"
          :currentDate="currentDate"
          :models="models"
          :loading="loading">
        </detail-notes>
      </v-col>

    </v-row>
    <template v-if="!currentModel && !loading">
      <h4>No Model</h4>
    </template>
  </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Page from './Page'
import Utils from '@/utils'
import { Headline } from '@/components/common'
import { TimeSeries } from '@/components/charts'
import DetailOverview from './detail/Overview'
import DetailNotes from './detail/Notes'
import SkeletonLoader from '@/components/common/SkeletonLoader'

const props = {
  chamber: {
    type: String,
    required: false
  }
}

const components = {
  Headline,
  Page,
  DetailOverview,
  DetailNotes,
  SkeletonLoader,
  TimeSeries
}

const computed = {
  ...mapGetters({
    electionModels: 'electionModels/list',
    mobile: 'ux/mobile'
  }),
  currentDate () {
    return this.$store.getters['aggregateModels/currentDate'](this.chamber)
  },
  raceId () {
    return this.$route.params.raceId
  },
  election () {
    return this.currentModel.election
  },
  models () {
    return this.electionModels.filter(model => model.election.raceId === this.raceId)
  },
  currentModel () {
    return this.models.find(model => model.date === this.currentDate)
  },
  getRaceState () {
    const obj = Utils.getColorScale(this.currentModel.rating)
    return `<span style="color: ${obj.textColor};">${obj.state}</span>`
  },
  getColor () {
    const obj = Utils.getColorScale(this.currentModel.rating)
    return obj.color
  }
}

const methods = {
  ...mapActions({
    getElectionModels: 'electionModels/list'
  }),
  fetchElectionModels () {
    this.loading = true
    this.getElectionModels({
      raceId: this.raceId,
      chamber: this.chamber
    }).then(() => {
      this.loading = false
    })
  }
}

const watch = {
  $route () {
    this.fetchElectionModels()
  }
}

export default {
  name: 'detail_wrapper',
  props,
  components,
  computed,
  methods,
  watch,
  data () {
    return {
      loading: false,
      scoreboardData: null,
      chartKey: 0
    }
  },
  beforeMount () {
    this.fetchElectionModels()
  }
}
</script>
